import { isPlatform } from '@ionic/vue'

const appStoreLink = 'https://apps.apple.com/us/app/sekai/id6504506653'
const googlePlayLink
  = 'https://play.google.com/store/apps/details?id=chat.sekai.app'

export function openStoreLink() {
  if (isPlatform('mobileweb')) {
    // open new tab
    if (isPlatform('ios')) {
      window.open(appStoreLink, '_blank')
    }
    else {
      window.open(googlePlayLink, '_blank')
    }
  }
}

export function openSekaiInApp(
  appScheme?: string,
  openStoreInFailed?: boolean,
) {
  const target = appScheme || `sekaiapp:/${window.location.pathname}`
  // 设置一个计时器，如果一定时间后页面还在，说明可能没有安装App
  setTimeout(() => {
    if (document.hidden || (document as any).webkitHidden) {
      // App可能已经打开，不做任何操作
    }
    else if (openStoreInFailed) {
      // 可能没有安装App，跳转到App Store
    }
  }, 2000) // 等待2秒

  // 尝试打开App
  window.location.href = target
}
